import React, { useRef } from "react";
import { Box, Card, CardBody, CardFooter, CardHeader, Image, Text } from "grommet";
import { GameViewModel } from "./GamesStore";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";
import ParallaxTilt from "../components/ParallaxTilt";
import ParallaxTilt2 from "../components/ParallaxTilt2";
import { normalizeColor } from "grommet/utils";
import Theme from "../utils/Theme";
import { useDarkMode } from "../components/DarkModeSwitch";
import Avatar from "react-avatar";

export const GameCard: React.FC<{ game: GameViewModel; width?: number }> = ({ game, width }) => {
    const [isDarkMode] = useDarkMode();
    const background = normalizeColor("background", Theme, isDarkMode);
    return (
        <ParallaxTilt2 style={{ backgroundImage: "url(" + game.splashUri + ")", backgroundColor: background }}>
            <Card width={!!width ? width + "px" : "250px"} height={!!width ? width * 1.5 + "px" : "375px"}>
                <CardBody align="center" justify="center">
                    <Box align="center">
                        {game.logoUri ? <Image src={game.logoUri} fit="contain" width="90%" height="90%" /> : <Avatar style={{ objectFit: "contain" }} name={game.name} round="10px" />}
                    </Box>
                </CardBody>
                <CardHeader pad="small" justify="center" fill="horizontal"></CardHeader>
                <CardFooter pad="small" background="background-front">
                    <Box direction="row" gap="small" justify="between" fill="horizontal">
                        <Text textAlign="center">{game.name}</Text>
                    </Box>
                </CardFooter>
            </Card>
        </ParallaxTilt2>
    );
};
